<template>
  <v-layout align-center>
    <v-flex sm6>
      <v-text-field
        v-model.trim="searchTerm"
        :label="label"
        class="vbt-hide-form-control-details"
        @keypress.enter="submit"
      />
    </v-flex>

    <v-btn
      :disabled="!searchTerm"
      small
      outlined
      color="info"
      class="ml-5 mt-1"
      @click="submit"
    >
      Search
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  name: 'OrderReferenceSearchBox',

  model: {
    event: 'input',
    prop: 'value',
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'Order ID, Invoice or Tracking Number',
    },
  },

  computed: {
    searchTerm: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },

  methods: {
    submit() {
      if (!this.searchTerm) {
        return;
      }

      this.$emit('submit');
    },
  },
};
</script>
